import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const taskCheckTypeConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default taskCheckTypeConfig;
